// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const idToken = await userCredential.user.getIdToken();
      localStorage.setItem('owly-sgi-idtoken', idToken);
      navigate('/projects');
    } catch (error) {
      setError(error.message);
    }
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');  
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src="/logo-owly.png" alt="Logo" className="logo" />  {/* Logo en la parte superior */}
        <h2>Iniciar Sesión</h2>
        {error && (
          <div>
            <div className='error-message'>
              Hubo un error: {error}
            </div>
            <br />
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              id="login-email"
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              id="login-password"
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit" className="login-button">Iniciar Sesión</button>
        </form>
        <button className="forgot-password-link" onClick={handleForgotPassword}>
          ¿Olvidaste tu contraseña?
        </button>
      </div>
    </div>
  );
}

export default Login;
